// Angular
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

// Application
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .then(success => {
    console.log('Bootstrap success');
    const preBootstrap = document.getElementById('preloader-container');

    // Add the class-name to initiate the transitions
    preBootstrap.className = 'loaded';

    // Remove the preloader container after the transition has completed
    setTimeout(
      function removeLoadingScreen() {
        preBootstrap
          .parentNode
          .removeChild(preBootstrap);
      }, 500);
  });
